import { PaginatedRequestParams } from "api";

export enum TicketSelFilterFormField {
  FIRSTNAME = 'SearchFirstName',
  LASTNAME = 'SearchLastName',
  EMAIL = 'SearchEmail',
  EVENTNAME = 'SearchEventName',
}
export type TicketSelFilterFormValues = {
  [TicketSelFilterFormField.FIRSTNAME]: string | undefined;
  [TicketSelFilterFormField.LASTNAME]: string | undefined;
  [TicketSelFilterFormField.EMAIL]: string | undefined;
  [TicketSelFilterFormField.EVENTNAME]: string | undefined;
};

export type TicketSelFilterFormValuesPaginated = TicketSelFilterFormValues &
  PaginatedRequestParams;